export default __webpack_public_path__ + "static/media/community-image.2a3de178.png";